"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var service_1 = require("../../../library/base/service");
var inviteActivity_1 = require("../../model/inviteActivity");
var RankList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RankList, _super);
    function RankList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '查询排名列表';
        _this.code = '300413';
        _this.desc = '查询排名列表';
        _this.requestParams = new inviteActivity_1.RankListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RankList;
}(service_1.BaseService));
exports.RankList = RankList;
//# sourceMappingURL=rankList.js.map